<template>
    <main>
        <div class="py-4 container-fluid">
            <div class="row">
                <div class="col-md-8">
                    <UserForm />
                </div>
                <div class="col-md-4">
                    <profile-card v-model="this.$store.state.currentUserInfo" />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import setNavPills from "@/assets/js/nav-pills.js";
    import setTooltip from "@/assets/js/tooltip.js";
    import ProfileCard from "../components/ProfileCard.vue";
    import UserForm from "./UserForm.vue";

    const body = document.getElementsByTagName("body")[0];

    export default {
        name: "profile",
        data() {
            return {
                showMenu: false,
                submitButtonStatus: true
            };
        },
        components: { ProfileCard, UserForm },
        methods: {
        },
        created() {
        },
        mounted() {
            this.$store.state.isAbsolute = true;
            setNavPills();
            setTooltip();
        },
        beforeMount() {
            this.$store.state.imageLayout = "profile-overview";
            this.$store.state.showNavbar = false;
            body.classList.add("profile-overview");
        },
        beforeUnmount() {
            this.$store.state.isAbsolute = false;
            this.$store.state.imageLayout = "default";
            this.$store.state.showNavbar = true;
            body.classList.remove("profile-overview");
        }
    };
</script>
